export const CREATE_PROGRAM_CATEGORY = `
  mutation createProgramCategory($input: CreateProgramCategoryInput!, $tenant_id: Int!) {
    createProgramCategory(input: $input, tenant_id: $tenant_id) {
      name
      include
      link
      pro_bono
      color
      usa_program_id
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;

export const UPDATE_PROGRAM_CATEGORY = `
  mutation updateProgramCategory($input: UpdateProgramCategoryInput!, $tenant_id: Int!) {
    updateProgramCategory(input: $input, tenant_id: $tenant_id) {
      id
      name
      include
      link
      pro_bono
      color
      usa_program_id
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;

export const DELETE_PROGRAM_CATEGORY = `
  mutation deleteProgramCategory($id: Int!, $tenant_id: Int!) {
    deleteProgramCategory(id: $id, tenant_id: $tenant_id) {
      id
    }
  }
`;
